<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Subject Update",
      items: [
        {
          text: "Subject",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        subjectid:"",
        lineError:true,
      form: {
          subject_name: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        subject_name: {
        required,
      },
    },
  },
    created() {
        this.subjectid = this.$route.params.id;
    },
    mounted() {
        this.getSubjectDetail();
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getSubjectDetail() {
          try {
              axios
                  .post("/api/support-ticket/subject/show/" + this.subjectid, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          var data = response.data.data;
                          this.form.subject_name = data.name;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/support-ticket/subject/update", {
            id:this.subjectid,
          name: this.form.subject_name,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
             this.$refs.subjectEntryForm.reset();
             this.$swal("Good job!", "Subject Update", "success");
            this.$router.push({ name: "support_ticket_subject_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      // console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="subjectEntryForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="subject_name">Subject Name</label>
                    <input
                      id="subject_name"
                      v-model="form.subject_name"
                      name="subject_name"
                      type="text"
                      class="form-control"
                      placeholder="Type subject name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.subject_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.subject_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.subject_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Update Subject</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
